import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SideNavService {
  private candidateIdSource = new BehaviorSubject<number>(0);
  candidateId$ = this.candidateIdSource.asObservable();

  setCandidateId(candidateId: number) {
    this.candidateIdSource.next(candidateId);
  }
}
